import * as API from '../api'

export const FETCH_MENU = 'FETCH_MENU'
export const FETCHING_MENU = 'FETCHING_MENU'
export const FETCH_MENU_ERROR = 'FETCH_MENU_ERROR'

const routes = [
  {
    id: 'mapa-de-produtos',
    name: 'Mapa de Produtos',
    open: false,
    subMenu: [
      {
        id: 'mapa-de-produtos/mapa-de-quimicos',
        name: 'Mapa de Químicos',
        functionality: 'product-map product-map-status'
      },
      {
        id: 'mapa-de-produtos/controle-de-certificados',
        name: 'Controle de certificados',
        functionality: 'certificate-control'
      }
    ]
  },
  {
    id: 'analise-de-incompatibilidade',
    name: 'Análise de Incompatibilidade',
    functionality: 'incompatibility-analysis incompatibility-analysis-edit'
  },
  {
    id: 'estoque-produtos-quimicos',
    name: 'Estoque de Produtos Quimicos',
    open: false,
    subMenu: [
      {
        id: 'estoque-produtos-quimicos/estoque',
        name: 'Estoque',
        functionality: 'inventory-stock'
      },
      {
        id: 'estoque-produtos-quimicos/historico',
        name: 'Histórico',
        functionality: 'inventory-historic'
      },
      {
        id: 'estoque-produtos-quimicos/historico-produtos-estoque',
        name: 'Relatório de movimentação em estoque',
        functionality: 'inventory-historic'
      },
      {
        id: 'estoque-produtos-quimicos/relatorio',
        name: 'Relatório Produtos Controlados',
        functionality: 'inventory-report'
      }
    ]
  },
  {
    id: 'produtos-controlados',
    name: 'Produtos Controlados',
    open: false,
    subMenu: [
      {
        id: 'produtos-controlados/licencas',
        name: 'Licenças',
        functionality: 'licenses'
      },
      {
        id: 'produtos-controlados/mapas-de-consumo',
        name: 'Mapas de Consumo',
        functionality: 'consumption-map'
      },
      {
        id: 'produtos-controlados/relacao-de-produtos-controlados',
        name: 'Relação de Produtos Controlados',
        functionality: 'controlled-products-map'
      },
      {
        id: 'produtos-controlados/relatorios',
        name: 'Relatórios',
        functionality: 'controlled-product-report'
      }
    ]
  },
  {
    id: 'licencas-terceiros',
    name: 'Licenças de Terceiros',
    functionality: 'third-parties'
  },
  {
    id: 'panorama-geral-de-produtos',
    name: 'Panorama Geral de Produtos',
    functionality: 'product-overview'
  },
  {
    id: 'controle-de-fispq',
    name: 'Controle de FISPQ',
    functionality: 'management-fispq'
  },
  {
    id: 'legislacao',
    name: 'Legislação',
    functionality: 'legislation'
  }
]

export const fetchMenu = () => {
  return dispatch => {
    dispatch({ type: FETCHING_MENU, value: true })

    return API.menu
      .getMenu()
      .then(response => {
        const data = [].concat(response.data)

        if (!data) {
          return {
            data: {
              items: []
            }
          }
        }

        const items = routes
          .filter(item => {
            if (item.subMenu) return true

            return data.find(func => {
              return item.functionality.includes(func.name)
            })
          })
          .map(item => {
            if (!item.subMenu) return item

            item.subMenu = item.subMenu.filter(subItem => {
              return data.find(func => {
                return subItem.functionality.includes(func.name)
              })
            })

            return item
          })
          .filter(item => {
            if (item.subMenu && !item.subMenu.length) {
              return false
            }

            return item
          })

        dispatch({ type: FETCH_MENU, items })
      })
      .catch(err => {
        dispatch({ type: FETCH_MENU_ERROR })
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/menu.js